import { render, staticRenderFns } from "./IdentifyFields.vue?vue&type=template&id=5bc4ff95&scoped=true&"
import script from "./IdentifyFields.vue?vue&type=script&lang=ts&"
export * from "./IdentifyFields.vue?vue&type=script&lang=ts&"
import style0 from "./IdentifyFields.vue?vue&type=style&index=0&id=5bc4ff95&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc4ff95",
  null
  
)

export default component.exports